export const COOKIE_KEY_DESKTOP_PTO_POPUP_CLOSE_STATUS = 'popupClosed';
export const COOKIE_KEY_DESKTOP_PTO_COUNTER_TIMER = 'ptoCounterTimer';

export const COOKIE_VALUE_DESKTOP_PTO_POPUP_CLOSED = 'true';
export const COOKIE_VALUE_DESKTOP_PTO_COUNTER_TIMER_END = 'true';
